"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getViewport = exports["default"] = exports.Tooltip = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactPortal = require("react-portal");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _tooltipModule = _interopRequireDefault(require("./tooltip.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var getViewport = function getViewport() {
  return {
    height: window.innerHeight || document.documentElement.offsetHeight,
    width: window.innerWidth || document.documentElement.offsetWidth,
    scrollX: window.scrollX,
    scrollY: window.scrollY
  };
};

exports.getViewport = getViewport;

var Tooltip = function Tooltip(_ref) {
  var _cx;

  var anchor = _ref.anchor,
      className = _ref.className,
      children = _ref.children,
      place = _ref.place,
      show = _ref.show,
      offset = _ref.offset,
      maxWidth = _ref.maxWidth,
      backgroundColor = _ref.backgroundColor,
      color = _ref.color;

  var _useState = (0, _react.useState)({
    left: anchor.x,
    top: anchor.y
  }),
      _useState2 = _slicedToArray(_useState, 2),
      topLeft = _useState2[0],
      setTopLeft = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      arrow = _useState4[0],
      setArrow = _useState4[1];

  var _useState5 = (0, _react.useState)({
    minWidth: 0,
    minHeight: 0
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      minSize = _useState6[0],
      setMinSize = _useState6[1];

  var tooltipRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (tooltipRef.current) {
      var x = anchor.x,
          y = anchor.y,
          width = anchor.width,
          height = anchor.height;

      var _getViewport = getViewport(),
          viewportHeight = _getViewport.height,
          viewportWidth = _getViewport.width,
          scrollY = _getViewport.scrollY,
          scrollX = _getViewport.scrollX;

      var _tooltipRef$current$g = tooltipRef.current.getBoundingClientRect(),
          tooltipHeight = _tooltipRef$current$g.height,
          tooltipWidth = _tooltipRef$current$g.width;

      setMinSize({
        minWidth: tooltipWidth,
        minHeight: tooltipHeight
      });
      var left;
      var top;

      if (place === 'right') {
        left = x + width + 5 + offset.x;
        top = y + height / 4 + offset.y;
        setArrow('left');
      }

      if (place === 'left') {
        left = x - width / 1.5 + offset.x;
        top = y + height / 4 + offset.y;
        setArrow('right');
      }

      if (place === 'bottom' || left + tooltipWidth >= viewportWidth + scrollX) {
        left = x + width / 2 - tooltipWidth / 2 + offset.x;
        top = y + height / 2 + tooltipHeight + offset.y;
        setArrow('top');
      }

      if (place === 'top' || top + tooltipHeight >= viewportHeight + scrollY) {
        left = x + width / 2 - tooltipWidth / 2 + offset.x;
        top = y - tooltipHeight + offset.y;
        setArrow('bottom');
      }

      setTopLeft({
        top: top,
        left: left
      });
    }
  }, [anchor, place, setMinSize, offset]);

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      animationDelay = _useState8[0],
      setAnimationDelay = _useState8[1];

  (0, _react.useEffect)(function () {
    var timeoutId;

    if (show) {
      timeoutId = setTimeout(function () {
        setAnimationDelay(true);
      }, 100);
    } else {
      setAnimationDelay(false);
    }

    return function () {
      return clearTimeout(timeoutId);
    };
  }, [show, animationDelay]);
  var backgroundStyle = {
    '--backgroundColor': backgroundColor
  };
  return show && /*#__PURE__*/_react["default"].createElement(_reactPortal.Portal, null, /*#__PURE__*/_react["default"].createElement("div", {
    ref: tooltipRef,
    className: (0, _classnames["default"])(animationDelay ? 'opacity-1' : 'opacity-0', 'absolute z-50 text-center p-2 rounded transition-opacity ease-linear duration-300', (_cx = {}, _defineProperty(_cx, _tooltipModule["default"].left, arrow === 'left'), _defineProperty(_cx, _tooltipModule["default"].right, arrow === 'right'), _defineProperty(_cx, _tooltipModule["default"].bottom, arrow === 'bottom'), _defineProperty(_cx, _tooltipModule["default"].top, arrow === 'top'), _cx), className),
    style: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, topLeft), minSize), {}, {
      maxWidth: maxWidth,
      color: color
    }, backgroundStyle), {}, {
      backgroundColor: backgroundColor
    })
  }, children));
};

exports.Tooltip = Tooltip;
Tooltip.propTypes = {
  anchor: _propTypes["default"].shape({
    y: _propTypes["default"].number,
    x: _propTypes["default"].number,
    width: _propTypes["default"].number,
    height: _propTypes["default"].number
  }).isRequired,
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  place: _propTypes["default"].string,
  show: _propTypes["default"].bool,
  offset: _propTypes["default"].shape({
    x: _propTypes["default"].number,
    y: _propTypes["default"].number
  }),
  maxWidth: _propTypes["default"].number,
  backgroundColor: _propTypes["default"].string,
  color: _propTypes["default"].string
};
Tooltip.defaultProps = {
  offset: {
    x: 0,
    y: 0
  },
  children: null,
  className: '',
  place: 'right',
  show: false,
  maxWidth: 400,
  backgroundColor: '#c1271f',
  color: 'white'
};
var _default = Tooltip;
exports["default"] = _default;